export function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export function normalizeSearchText(text) {
  if (Array.isArray(text)) {
    return text.join("； ")
  }
  if (text == null) {
    return ""
  }
  return typeof text === "string" ? text : String(text)
}

export function sanitizeSearchQuery(query) {
  const normalized = normalizeSearchText(query).replace(
    /[\\^$.*+?()[\]{}|"'`]+/g,
    " "
  )

  return normalized.replace(/\s+/g, " ").trim()
}

function buildPatternTokens(query) {
  const tokens = sanitizeSearchQuery(query)
    .split(/\s+/)
    .filter(Boolean)
    .reduce((parts, token) => {
      if (token.length > 1) {
        parts.push(token)
      } else {
        parts.push(...token.split(""))
      }
      return parts
    }, [])

  return [...new Set(tokens)].sort((a, b) => b.length - a.length)
}

export function sliceSearchText(text, query, topBar) {
  const source = normalizeSearchText(text)
  const safeQuery = sanitizeSearchQuery(query)
  const n = topBar ? 48 : 83

  if (source.length < n || !safeQuery.length) return source

  const match = source.match(new RegExp(escapeRegExp(safeQuery), "i"))
  if (match) {
    const { index } = match
    const start = index - 20 > 0 ? index - 20 : 0
    const nn = n - (index - start)
    const end = index + nn < source.length ? index + nn : source.length
    let newText = source.slice(start, end)
    if (start > 0) {
      newText = "..." + newText
    }
    if (end < source.length) {
      newText = newText + "..."
    }
    return newText
  }

  return source.slice(0, n)
}

export function buildHighlightParts(text, query, options = {}) {
  const source = options.slice
    ? sliceSearchText(text, query, options.topBar)
    : normalizeSearchText(text)
  const tokens = buildPatternTokens(query)

  if (!source.length || !tokens.length) {
    return [{ text: source, match: false }]
  }

  const matcher = new RegExp(`(${tokens.map(escapeRegExp).join("|")})`, "gi")
  const segments = source.split(matcher).filter(part => part.length > 0)

  return segments.map(part => ({
    text: part,
    match: tokens.some(token => token.toLowerCase() === part.toLowerCase()),
  }))
}
